
<div class="">
  <div
    v-if="!disableAltText"
    class="row"
  >
    <div class="col text-capitalize">
      {{ $t("element.property.image.alt.label") }}
    </div>
    <div class="col-12">
      <cvt-input
        v-model="alt"
        type="text"
        :placeholder="$t('element.property.image.alt.alt_message')"
      />
    </div>
  </div>

  <div
    v-if="!disableAltText"
    class="divider"
  />

  <div class="row">
    <div
      v-if="OrgName !== orgNameFreshWork"
      class="col text-capitalize"
    >
      {{ $t("element.property.link") }}
    </div>
    <div v-else class="col align-items-center">
      <h6 :class="textColorClass" >Hyperlink image</h6>
    </div>
    <div class="col-12">
      <url-input
        v-model="href"
        type="text"
        :placeholder="$t('element.property.image.alt.link_message')"
      />
    </div>
  </div>
</div>
